import PUBLIC_PAGE_STATUS from 'constants/publicPage';
import { IPublicPageDocumentStructure } from 'types/PublicPage';

const getCorrectDocumentIDToSign = (documents: IPublicPageDocumentStructure[]): number => (
  documents
    .find((document: IPublicPageDocumentStructure): boolean => (document.status !== PUBLIC_PAGE_STATUS.DONE))?.id
  ?? 0
);

export default getCorrectDocumentIDToSign;